// Where the node sits, a frame of shot 6, at the film's size and rate after
// the 0.3s head trim build-cut.sh takes: on the phone face down on the dash.
// From sparse optical flow over the dash the phone rides, held to the phone
// itself by a template match (scratchpad track6.py), smoothed over three
// frames, so the node rides the dash with the cab.
export type Pt = [x: number, y: number];
export const TRACK6: Pt[] = [
  [235.0, 950.0],
  [235.0, 952.3],
  [234.4, 957.0],
  [232.5, 964.2],
  [229.6, 971.6],
  [226.5, 978.5],
  [224.8, 984.2],
  [225.2, 988.8],
  [229.3, 992.7],
  [235.9, 996.4],
  [244.1, 1000.5],
  [252.3, 1005.2],
  [260.5, 1010.4],
  [269.2, 1015.6],
  [280.5, 1020.1],
  [286.6, 1025.5],
  [290.4, 1030.7],
  [289.5, 1036.0],
  [291.3, 1039.2],
  [292.6, 1041.6],
  [293.3, 1043.2],
  [293.9, 1044.1],
  [294.9, 1044.1],
  [297.2, 1043.2],
  [300.7, 1041.8],
  [305.1, 1040.3],
  [309.4, 1039.3],
  [313.6, 1039.0],
  [317.3, 1039.5],
  [320.4, 1040.6],
  [322.6, 1042.1],
  [324.0, 1043.6],
  [324.4, 1044.8],
  [324.1, 1045.5],
  [322.9, 1045.9],
  [320.9, 1045.8],
  [318.0, 1045.4],
  [314.6, 1045.1],
  [311.2, 1045.2],
  [307.6, 1045.3],
  [303.9, 1045.1],
  [300.8, 1044.5],
  [299.1, 1043.5],
  [298.6, 1042.2],
  [299.5, 1040.9],
  [300.9, 1039.9],
  [302.6, 1039.5],
  [304.0, 1039.3],
  [305.3, 1038.8],
  [305.9, 1037.4],
  [304.9, 1035.1],
  [302.0, 1031.9],
  [299.9, 1027.4],
  [294.3, 1023.3],
  [287.9, 1019.0],
  [279.6, 1014.8],
  [274.8, 1009.0],
  [271.1, 1003.3],
  [268.4, 998.0],
  [266.5, 993.9],
  [266.0, 990.0],
  [265.7, 986.6],
  [264.9, 983.5],
  [263.6, 981.2],
  [261.7, 979.6],
  [259.6, 978.4],
  [257.1, 977.8],
  [254.7, 977.8],
  [253.4, 978.5],
  [253.4, 979.1],
  [255.0, 979.0],
  [257.5, 978.3],
  [260.7, 977.2],
  [264.0, 976.2],
  [266.9, 975.2],
  [269.3, 974.1],
  [270.8, 973.0],
  [271.1, 972.2],
  [270.4, 971.8],
  [268.4, 972.0],
  [266.3, 972.7],
  [264.3, 973.9],
  [263.3, 975.1],
  [263.2, 975.8],
  [264.0, 976.2],
  [265.3, 976.1],
  [266.7, 976.2],
  [267.8, 975.8],
  [268.4, 975.3],
  [268.3, 975.0],
  [267.2, 974.7],
  [265.4, 974.2],
  [263.6, 973.0],
  [263.2, 971.7],
  [264.6, 970.3],
  [267.8, 969.5],
  [271.7, 969.1],
  [275.8, 968.9],
  [279.2, 969.1],
  [281.5, 969.6],
  [282.4, 970.8],
  [282.1, 972.7],
  [281.0, 974.8],
  [279.5, 976.8],
  [277.9, 978.9],
  [276.8, 981.5],
  [276.7, 984.4],
  [277.7, 987.7],
  [279.6, 991.3],
  [282.2, 995.1],
  [285.3, 999.0],
  [288.4, 1002.7],
  [291.1, 1006.2],
  [292.4, 1009.2],
  [292.3, 1011.7],
  [290.9, 1013.4],
  [287.3, 1015.2],
  [283.2, 1016.8],
  [279.1, 1018.2],
  [276.7, 1018.6],
  [274.9, 1018.2],
  [273.6, 1017.2],
  [273.1, 1015.9],
  [273.8, 1014.8],
  [275.7, 1014.0],
  [278.5, 1013.4],
  [281.6, 1012.8],
  [284.3, 1012.4],
  [286.3, 1012.6],
  [287.2, 1013.4],
  [287.0, 1014.4],
  [286.1, 1015.0],
  [285.1, 1014.8],
  [284.3, 1013.6],
  [283.4, 1011.8],
  [282.5, 1009.5],
  [281.2, 1007.4],
  [279.3, 1005.0],
  [277.8, 1003.5],
];
